// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"77dc2e1a","511":"5ccbcd45","820":"e3eb39fb"}[chunkId] + ".chunk.js";
};